<template>
  <section class="container rawhtml-block" :class="theme_color">
    <div class="content" v-html="value">
    </div>
  </section>
</template>

<script>
export default {
  name: 'BlockRawhtml',
  props: ['value', 'theme'],
  computed: {
    theme_color () {
      return this.theme.value.theme
    }
  }
}
</script>
